module.exports = __webpack_public_path__ + "static/media/023.d42d821c.jpg";